//import AccountLayout from '../layouts/AccountLayout.jsx';
import LoginPage from '../pages/Login-page';
import Logout from '../pages/Logout';
import { DefaultLayout } from '../layouts';

export const accountRoutes = [ 
    {
        path: '/login',
        element: LoginPage,
        layout: DefaultLayout,
        secure: false
    }, 
    {
        path: '/login/:backtologin',
        element: LoginPage,
        layout: DefaultLayout,
        adminPage: false
    },
    {
        path: '/logout',
        element: Logout,
        layout: DefaultLayout,
        secure: false
    }
];
